/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-08-23 14:17:07
 **/

import { BaseServiceV2 } from "@/frameworks/libraries/restservice";

class MyDeskBase extends BaseServiceV2 {
	constructor() {
		super();
	}

	protected _basePath = "/api/my_desk";
}

class MyDesk extends MyDeskBase {
	constructor() {
		super();
	}

	public saveBackground = {
		name: "mydesk:saveBackground",
		execute: (
			parameter: WebServices.MyDesk.Configure.SaveBackground.Request = {}
		): Promise<WebServices.MyDesk.Configure.SaveBackground.Response> =>
			this.post(this.saveBackground.name, this._basePath + "/background", parameter, {
				headers: { "Content-Type": "multipart/form-data" }
			})
	};

	public inquiry = {
		name: "mydesk:inquiry",
		execute: (
			parameter: WebServices.MyDesk.Configure.Inquiry.Request = {}
		): Promise<WebServices.MyDesk.Configure.Inquiry.Response> =>
			this.get(this.inquiry.name, this._basePath, parameter)
	};

	public deleteCustomBackground = {
		name: "mydesk:deleteCustomBackground",
		execute: (
			parameter: WebServices.MyDesk.Configure.RemoveCustomBackground.Request = {}
		): Promise<WebServices.MyDesk.Configure.RemoveCustomBackground.Response> =>
			this.delete(this.deleteCustomBackground.name, this._basePath + "/custom", parameter)
	};

	public saveWidget = {
		name: "mydesk:saveWidget",
		execute: (
			parameter: WebServices.MyDesk.Configure.SaveWidget.Request = {}
		): Promise<WebServices.MyDesk.Configure.SaveWidget.Response> =>
			this.post(this.saveWidget.name, this._basePath + "/widgets", parameter)
	};
}

class MyDeskKnock extends MyDeskBase {
	constructor() {
		super();
	}

	public request = {
		name: "mydesk:knock:request",
		execute: (
			parameter: WebServices.MyDesk.Knock.Request.Request
		): Promise<WebServices.MyDesk.Knock.Request.Response> =>
			this.post(this.request.name, this._basePath + "/knock", parameter)
	};

	public reply = {
		name: "mydesk:knock:reply",
		execute: (
			parameter: WebServices.MyDesk.Knock.Reply.Request
		): Promise<WebServices.MyDesk.Knock.Reply.Response> =>
			this.post(this.reply.name, this._basePath + "/knock/reply", parameter)
	};
}

class MyDeskNotification extends MyDeskBase {
	constructor() {
		super();
	}

	public inquiry = {
		name: "myDesk:notificationLogs:inquiry",
		execute: (
			parameter: WebServices.MyDesk.Notification.Inquiry.Request = {}
		): Promise<WebServices.MyDesk.Notification.Inquiry.Response> =>
			this.get(this.inquiry.name, this._basePath + "/notification_logs", parameter)
	};

	public deleteNotification = {
		name: "myDesk:notificationLogs:delete",
		execute: (
			parameter: WebServices.MyDesk.Notification.Delete.Request
		): Promise<WebServices.MyDesk.Notification.Delete.Response> =>
			this.post(this.deleteNotification.name, this._basePath + `/notification_logs/delete`, parameter)
	};
}

export default class MyDeskService {
	constructor(
		events: API.Events,
		public readonly myDesk = new MyDesk(),
		public readonly knock = new MyDeskKnock(),
		public readonly notification = new MyDeskNotification()
	) {
		myDesk.set_event(events);
		knock.set_event(events);
		notification.set_event(events);
	}
}
